module.exports = __webpack_public_path__ + "media/images/step2-7146a3e80b1b9bc39fb6af92abe58861.png";